module.exports = __webpack_public_path__ + "src/assets/img/share-bg.693b6c4d.png";